export default __webpack_public_path__ + "static/media/Vector222.17c613ad.svg";